import type { MessageKey } from 'types/LocaleMessageKey';

import { _getDiscountAppliedMessage } from './_getDiscountAppliedMessage';
import { _getNoDiscount } from './_getNoDiscount';
import type { DiscountError, GetDiscountMessage } from './types';

const getDiscountMessage = ({
  appliedDiscountCode,
  campaign,
  discount,
  discountIsLoading,
  discountIsSuccess,
  isOuraRing4Wizard,
  isPrimeSitewide,
  isUS,
  promotionCodes,
  showUrlDiscount,
  sitewideDiscounts,
  statsigDiscountArray,
  urlPromotionData,
}: GetDiscountMessage): MessageKey | null => {
  const invalidReason = urlPromotionData?.invalidReason ?? null;

  let discountError: DiscountError = {
    errorMessage: null,
    invalidReason,
  };

  const hasDiscountResolved =
    (appliedDiscountCode || campaign) &&
    !discountIsLoading &&
    discountIsSuccess;

  if (hasDiscountResolved) {
    // check if discount is not valid
    discountError = _getNoDiscount({
      discount,
      invalidReason,
      valid: discount?.valid,
    });
  }

  const { errorMessage, invalidReason: reason } = discountError;

  return _getDiscountAppliedMessage({
    appliedDiscountCode,
    campaign,
    errorCode: urlPromotionData?.errorCode,
    errorMessage,
    discountError,
    isOuraRing4Wizard,
    isPrimeSitewide,
    isUS,
    promotionCodes,
    reason,
    showUrlDiscount,
    sitewideDiscounts,
    statsigDiscountArray,
  });
};

export default getDiscountMessage;
